"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonSchema = void 0;
const zod_1 = require("zod");
const period_1 = require("../period");
exports.ComparisonSchema = zod_1.z.object({
    kind: zod_1.z.literal('time'),
    period: period_1.RelativePeriodSchema,
    mode: zod_1.z.enum(['absolute', 'relative']),
});
//# sourceMappingURL=comparisonSchema.js.map